export const DATA_LOADING = 'DATA_LOADING';
export const DATA_FAILED = 'DATA_FAILED';
export const DATA_LOADED = 'DATA_LOADED';
export const DATA_CLEARED = 'DATA_CLEARED';
